export default __webpack_public_path__ + "static/media/indoorrowing.d6c08542.png";